import React from 'react';
import Container from '../../components/container/Container';
import Client from '../../types/Client';
import Input from '../../components/questionnaire/Input';
import Routes from '../../util/routes';
import LinkDiv from '../../components/link/LinkDiv';

function LeftPanelComponent() {
  return (
    <>
      <h3>Choix du client</h3>
      <p className="mb-4">Choisissez un client pour commencer la visio, ou créez en un</p>
        <LinkDiv to={Routes.CREATE_CLIENT}>
          <div className="dbox w-100 d-flex align-items-center">
              <div className="icon d-flex align-items-center justify-content-center cursor-button">
                <span className="fa fa-plus-circle" />
              </div>
              <div className="text pl-3">
                <p className="cursor-button">Creer un client</p>
              </div>
          </div>
        </LinkDiv>
    </>
  );
}

function ListClients({ clients, onSelect }: { clients: Client[], onSelect: (client: Client) => void }) {
  const onChange = (client: Client) => () => {
    console.log('[ListClient] select client:', client);
    onSelect(client);
  }
  return (
    <Container title="Clients" leftPanelComponent={<LeftPanelComponent />}>
      <div className="contact-wrap w-100 p-md-5 p-4">
        <h3 className="mb-4">Mes clients</h3>
        <div className="row">
          {clients.map((client, index) => (
            <Input key={index} name="choose-client" label={`(${client.idclient}) ${client.nom} ${client.prenom} ${client.email}`} type="radio" onChange={onChange(client)} /> 
          ))}
        </div>
      </div>
    </Container>
  );
}

export default ListClients;
